<span class="status-pill">
  <span class="status-dot status-dot--{{ dot }}" aria-hidden="true"></span>
  <span class="status-pill-label">
    <ng-container *ngIf="labelKey; else rawStatus">{{ labelKey | translate }}</ng-container>
    <ng-template #rawStatus>{{ status }}</ng-template>
  </span>
</span>
